import { AppInfo } from "./utils/app-info";

export function setFaviconByDomain() {
  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/x-icon";
  link.href = AppInfo.get("favicon");

  document.head.appendChild(link);

  // title as well
  const title = document.querySelector("title");
  if (title) {
    title.textContent = AppInfo.get("title");
  }
}
